import { createStyles } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    alert: {
        width: "100%",
    },
    container: {
        flexDirection: "column",
        width: "100%",
        maxWidth: "var(--form-main-content-max-width)",
        padding: theme.spacing.md,
        gap: theme.spacing.md,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.fn.largerThan("xs")]: {
            padding: "2em 1.5em",
            gap: "1.5em",
        },

        [theme.fn.largerThan("md")]: {
            flexDirection: "row",
            justifyContent: "space-between",
            padding: "2.5em 0",
            gap: "2.5em",
        },
    },
    placeholder: {
        alignItems: "center",
        textAlign: "center",

        [theme.fn.largerThan("md")]: {
            padding: "0",
            flexDirection: "column",
            gap: "1em",
            flex: 1,
            maxWidth: "116px",
        },
    },
    item: {
        width: "calc(100% - 1.5rem)",

        "::marker": {
            color: theme.colors.red[9],
        },

        "a:link, a:visited, a:focus, a:hover, a:active": {
            color: theme.colors.gray[8],
        },
    },
    link: {
        textAlign: "initial",
    },
    summary: {
        flex: 3,
    },
}))
